export const contentData = {
  spanish:{
    layout:{
      title:'Editar Asesor',
      navigation:[
        {name:'Asesores',path:'/agents'},
        {name:'Detalles',path:'/agents/'},
        {name:'Editar',path:'/agents/edit'},
        
      ],
      menu2:[
        {id:0, label:'Mis datos'},
        {id:1, label:'Horario'},
      ],
    },
    password_modal:{
      label:'Cambiar Contraseña',
      button:'Actualizar',
      cancelButton:'Cancelar',
    },
  },
}